<template>
  <div class="kl-contact">
    <div class="kl-contact__inner">
      <!-- ===================== FORMULARIO ===================== -->
      <div class="kl-contact__form">
        <div class="d-flex kl-field-row">
          <b-form-input
            class="contact-input mr-2"
            id="Nombre"
            v-model="$v.form.name.$model"
            :state="validateState('name')"
            :placeholder="$t('home.contact.fullName')"
          ></b-form-input>
          <b-form-input
            class="contact-input"
            id="Email"
            v-model="$v.form.email.$model"
            :state="validateState('email')"
            :placeholder="$t('home.contact.email')"
          ></b-form-input>
        </div>
        <div class="d-flex kl-field-row">
          <b-form-input
            class="contact-input mr-2"
            id="Cargo"
            v-model="$v.form.position.$model"
            :state="validateState('position')"
            :placeholder="$t('home.contact.position')"
          ></b-form-input>
          <b-form-input
            class="contact-input"
            id="Institución"
            v-model="$v.form.institution.$model"
            :state="validateState('institution')"
            :placeholder="$t('home.contact.institution')"
          ></b-form-input>
        </div>
        <div class="d-flex kl-field-row">
          <b-form-input
            class="contact-input mr-2"
            id="País"
            v-model="$v.form.country.$model"
            :state="validateState('country')"
            :placeholder="$t('home.contact.country')"
          ></b-form-input>
          <b-form-input
            class="contact-input"
            id="Teléfono"
            v-model="$v.form.phone.$model"
            :state="validateState('phone')"
            :placeholder="$t('home.contact.phone')"
          ></b-form-input>
        </div>
        <b-form-textarea
          class="contact-input contact-textarea"
          id="Mensaje"
          v-model="$v.form.message.$model"
          :state="validateState('message')"
          :placeholder="$t('home.contact.message')"
          rows="4"
          max-rows="6"
        ></b-form-textarea>

        <div class="kl-contact__actions">
          <template
            v-if="disabled_button || ($v.form.$dirty && $v.form.$anyError)"
          >
            <b-button class="contact-button-disable" disabled>{{
              $t("home.contact.send").toUpperCase()
            }}</b-button>
          </template>
          <b-button v-else class="contact-button" @click="send">{{
            $t("home.contact.send").toUpperCase()
          }}</b-button>

          <small class="recaptcha-attribution mt-2 d-block">
            {{ $t("home.contact.recaptchaAttribution") }}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener"
              >{{ $t("home.contact.recaptchaPrivacyPolicy") }}</a
            >
            {{ $t("home.contact.recaptchaAnd") }}
            <a
              href="https://policies.google.com/terms"
              target="_blank"
              rel="noopener"
              >{{ $t("home.contact.recaptchaTermsOfService") }}</a
            >
            {{ $t("home.contact.recaptchaApply") }}
          </small>
        </div>
      </div>

      <!-- ===================== PANEL LATERAL ===================== -->
      <div class="kl-contact__aside">
        <div class="kl-contact__decor" aria-hidden="true"></div>
        <div class="kl-contact__aside-inner">
          <h2 class="kl-contact__title">
            {{ $t("home.contact.contactUsTitle") }}
          </h2>
          <p class="kl-contact__desc">
            {{ $t("home.contact.contactDescription") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import recaptchaService from "@/services/recaptcha.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "ContactForm",
  mixins: [validationMixin],
  components: {},
  props: {},
  data() {
    return {
      disabled_button: false,
      form: {
        name: "",
        email: "",
        position: "",
        institution: "",
        country: "",
        phone: "",
        message: "",
      },
    };
  },
  validations: {
    form: {
      name: { required },
      email: {
        required,
        isValid() {
          if (
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
              this.form.email
            )
          ) {
            return true;
          } else return false;
        },
      },
      position: { required },
      institution: { required },
      country: { required },
      phone: {},
      message: { required },
    },
  },
  computed: {},
  methods: {
    validateState(key) {
      const { $dirty, $error } = this.$v.form[key];
      return $dirty ? !$error : null;
    },
    // async testRecaptcha() {
    //   try {
    //     const token = await recaptchaService.execute("TEST");
    //     const response = await this.$restful.Post(
    //       `/common/verify-recaptcha/`,
    //       { recaptcha_token: token, action: "TEST" }
    //     );
    //     this.$swal.fire({
    //       type: "success",
    //       title: "reCAPTCHA Verificado",
    //       html: `<div style="text-align:left;"><strong>Score:</strong> ${response.score}<br><strong>Razón:</strong> ${response.reason}</div>`,
    //       confirmButtonText: "Cerrar",
    //     });
    //     console.log("reCAPTCHA result:", response);
    //   } catch (error) {
    //     console.error("reCAPTCHA error completo:", error);
    //     const detail =
    //       error.response?.data?.detail ||
    //       error.response?.data?.error ||
    //       error.detail ||
    //       error.error ||
    //       error.message ||
    //       JSON.stringify(error);
    //     this.$swal.fire({
    //       type: "error",
    //       title: "reCAPTCHA Error",
    //       text: detail,
    //     });
    //   }
    // },
    async send() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) return;
      this.disabled_button = true;
      try {
        const recaptcha_token = await recaptchaService.execute("CONTACT");
        await this.$restful.Post(`/common/contact-data/`, {
          ...this.form,
          recaptcha_token,
        });
        this.$swal.fire({
          type: "success",
          title: this.$t("home.contact.messageSent"),
          showConfirmButton: false,
          timer: 2500,
        });
        this.form.name = "";
        this.form.email = "";
        this.form.position = "";
        this.form.institution = "";
        this.form.country = "";
        this.form.phone = "";
        this.form.message = "";
      } catch (error) {
        this.$swal.fire({
          type: "error",
          title: this.$t("reusable.common.error"),
          showConfirmButton: false,
          timer: 2500,
        });
      } finally {
        this.disabled_button = false;
      }
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
/* ============================================================
   KeyLearning · Formulario de contacto
   (alineado con el sistema de diseño de la página pública)
   ============================================================ */
.kl-contact {
  /* Migrado al sistema global de tokens (utils/styles_kl.css). */
  --kl-blue: var(--kl-color-primary);
  --kl-blue-dark: var(--kl-color-primary-deep);
  --kl-teal: var(--kl-color-secondary);
  --kl-ink: var(--kl-text-heading);
  --kl-text: var(--kl-text-body);
  --kl-bg: var(--kl-bg-page);
  --kl-card: var(--kl-surface);
  --kl-border: var(--kl-border-soft);
  --kl-shadow: var(--kl-shadow-lg);

  background: var(--kl-bg);
  padding: 80px 32px;
}
.kl-contact__inner {
  max-width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  background: var(--kl-card);
  border: 1px solid var(--kl-border);
  border-radius: 24px;
  box-shadow: var(--kl-shadow);
  overflow: hidden;
}

/* ---------- Columna del formulario ---------- */
.kl-contact__form {
  padding: 52px 48px;
}
.kl-field-row {
  gap: 0;
}

/* Inputs (b-form-input/b-form-textarea exponen .form-control) */
.contact-input {
  box-sizing: border-box;
  height: 50px;
  padding: 0 16px;
  margin-bottom: 16px;
  border: 1.5px solid rgba(0, 110, 200, 0.35);
  border-radius: var(--kl-radius-lg);
  background-color: #f5f9fd;
  color: var(--kl-ink);
  font-size: var(--kl-fs-body);
  transition: border-color 0.25s ease, box-shadow 0.25s ease,
    background-color 0.25s ease;
}
.contact-textarea {
  height: auto;
  padding: 14px 10px 14px 16px;
  resize: none;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 110, 200, 0.45) transparent;
}
.contact-textarea::-webkit-scrollbar {
  width: 6px;
}
.contact-textarea::-webkit-scrollbar-track {
  background: transparent;
  margin: 10px 0;
}
.contact-textarea::-webkit-scrollbar-thumb {
  background: rgba(0, 110, 200, 0.4);
  border-radius: 999px;
}
.contact-textarea::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 110, 200, 0.65);
}
.contact-input:hover {
  border-color: rgba(0, 110, 200, 0.55);
}
.contact-input:focus,
.contact-input.form-control:focus {
  border-color: var(--kl-blue);
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(0, 110, 200, 0.15);
}
.contact-input::placeholder {
  color: #9aa6b3;
  opacity: 1;
}
.contact-input:-ms-input-placeholder {
  color: #9aa6b3;
}
.contact-input::-ms-input-placeholder {
  color: #9aa6b3;
}

/* ---------- Botón ---------- */
.kl-contact__actions {
  margin-top: 6px;
}
.contact-button {
  background: linear-gradient(135deg, var(--kl-blue) 0%, var(--kl-teal) 100%);
  border: none;
  border-radius: 14px;
  height: 56px;
  width: 100%;
  font-weight: var(--kl-fw-bold);
  letter-spacing: 0.5px;
  box-shadow: 0 10px 24px rgba(0, 110, 200, 0.28);
  transition: transform 0.25s ease, box-shadow 0.25s ease, filter 0.25s ease;
}
.contact-button:hover {
  transform: translateY(-2px);
  filter: brightness(1.05);
  box-shadow: 0 14px 30px rgba(0, 110, 200, 0.35);
}
.contact-button-disable {
  background: #cdd5de;
  border: none;
  border-radius: 14px;
  height: 56px;
  width: 100%;
  font-weight: var(--kl-fw-bold);
  letter-spacing: 0.5px;
  opacity: 0.7;
  cursor: not-allowed !important;
}
.recaptcha-attribution {
  color: var(--kl-text-muted);
  font-size: var(--kl-fs-caption);
  text-align: center;
}
.recaptcha-attribution a {
  color: var(--kl-blue);
}

/* ---------- Panel lateral (degradado de marca) ---------- */
.kl-contact__aside {
  position: relative;
  display: flex;
  align-items: center;
  padding: 52px 48px;
  background: linear-gradient(
    150deg,
    var(--kl-blue-dark) 0%,
    var(--kl-blue) 60%,
    var(--kl-teal) 120%
  );
  color: #ffffff;
  overflow: hidden;
}
.kl-contact__decor {
  position: absolute;
  top: -90px;
  right: -70px;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  background: radial-gradient(
    circle at center,
    rgba(255, 255, 255, 0.18) 0%,
    rgba(255, 255, 255, 0) 70%
  );
  pointer-events: none;
}
.kl-contact__aside-inner {
  position: relative;
  z-index: 1;
}
.kl-contact__title {
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-title-fluid);
  line-height: var(--kl-lh-tight);
  margin: 0 0 18px;
  letter-spacing: var(--kl-ls-tight);
}
.kl-contact__desc {
  font-weight: var(--kl-fw-regular);
  font-size: var(--kl-fs-body-lg);
  line-height: var(--kl-lh-relaxed);
  color: rgba(255, 255, 255, 0.92);
  margin: 0;
  text-align: justify;
}

/* ============================================================
   Responsive
   ============================================================ */
@media (max-width: 992px) {
  .kl-contact {
    padding: 56px 22px;
  }
  .kl-contact__inner {
    grid-template-columns: 1fr;
  }
  .kl-contact__aside {
    order: -1;
    padding: 44px 36px;
  }
  .kl-contact__form {
    padding: 40px 36px;
  }
}

@media (max-width: 560px) {
  .kl-field-row {
    flex-direction: column;
  }
  .kl-field-row .contact-input.mr-2 {
    margin-right: 0 !important;
  }
  .kl-contact__form,
  .kl-contact__aside {
    padding: 32px 24px;
  }
}
</style>